import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

export interface ReasonCodesResponse {
  reasonCodes: { code: string; label: string }[];
}

export const useReferReasonCodes = () => {
  return useApi<ReasonCodesResponse>({
    queryOptions: {
      enabled: true,
      queryFn: async () => {
        const response = await axiosInstance.get<ReasonCodesResponse>(
          "/amazon-clinic/care-plans/refer-out/reason-codes",
        );

        return response.data;
      },
      queryKey: QueryKeys.Reference.Referrals.REASON_CODES,
      staleTime: Number.POSITIVE_INFINITY,
    },
  });
};
